export const UNLOCK = 'unlock'
export const ENVELOPE = 'envelope'
export const CHECK_CIRCLE = 'check-circle'
export const WARNING = 'warning'
